import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgPackagingGlyphSecondary from './svgs/PackagingGlyphSecondary.js';
import SvgPackagingGlyph from './svgs/PackagingGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var packagingGlyph = (props => useIcon(SvgPackagingGlyph, SvgPackagingGlyphSecondary, props));

export { packagingGlyph as default };
